<div class="notifications-page">
    <div class="settings">
        <ng-container *ngIf="isFactoringUser">
            <div class="settings-header">
                <h2 class="section-heading h3">
                    {{ titleI18n }}
                </h2>
            </div>
            <div class="settings-body">
                <div class="preferences-header">
                    <div>
                        <h2 class="section-heading updates">{{ updatesTitleI18n }}</h2>
                        <p>{{ updatesDescriptionI18n }}</p>
                    </div>
                </div>

                <div class="preferences-body">
                    <div class="communication-types">
                        <!-- Add a header here for future communication types (email, text, ...) -->
                        <h4 class="communication-types-header">
                            {{ inAppTitleI18n }}
                        </h4>
                    </div>
                    <div
                        class="preferences-body-group"
                        *ngFor="let preferenceGroup of notificationPreferencesGroups"
                    >
                        <h2 class="section-heading h3">
                            {{ preferenceGroup.groupName }}
                        </h2>
                        <div
                            class="preferences-body-group-row"
                            *ngFor="let preferenceControl of preferenceGroup.preferenceControls"
                        >
                            <div class="preferences-body-group-row-title">
                                <span>{{ preferenceControl.label }}</span>
                            </div>
                            <div class="preferences-body-group-row-switches">
                                <!-- Add a switch here for future communication types (email, text, ...) -->
                                <lsq-switch
                                    [(ngModel)]="preferenceControl.inAppIsOn"
                                    (ngModelChange)="
                                        handlePreferenceChange(
                                            preferenceControl.notificationType,
                                            preferenceControl.inAppIsOn
                                        )
                                    "
                                    [name]="preferenceControl.id"
                                >
                                </lsq-switch>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="isDirectSupplierUser || isPlatformSupplierUser || isBuyerUser">
            <div class="section-header">
                <h2 class="section-heading h3">
                    {{ titleI18n }}
                </h2>
            </div>
            <div class="notification-cards-container">
                <div
                    class="notification-card"
                    *ngFor="let notificationSetting of notificationSettings"
                >
                    <div class="notification-title">{{ notificationSetting.title }}</div>
                    <div class="notification-description">
                        {{ notificationSetting.label }}
                    </div>
                    <div class="notification-switches">
                        <lsq-switch
                            [(ngModel)]="notificationSetting.emailIsOn"
                            i18n-label="notification switch label for email"
                            label="EMAIL"
                            (ngModelChange)="
                                handlePreferenceChange(
                                    notificationSetting.notificationType,
                                    notificationSetting.emailIsOn
                                )
                            "
                            [labelOrientation]="orientation.Top"
                            [name]="notificationSetting.id"
                        >
                        </lsq-switch>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>
